
import React, { useState, useEffect } from 'react';
import { Button } from './ui/Button';

export const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('mabelita_cookie_consent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('mabelita_cookie_consent', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 shadow-[0_-4px_10px_rgba(0,0,0,0.1)] z-50 p-4 md:p-6 animate-in slide-in-from-bottom duration-500">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-sm text-gray-600">
          <p>
            <strong>🍪 Usamos cookies</strong> para mantener tu carrito guardado, mejorar tu experiencia y analizar el tráfico. 
            Al continuar navegando, aceptas nuestra <a href="#cookies" className="text-mabelita-primary underline hover:text-mabelita-hover">Política de Cookies</a>.
          </p>
        </div>
        <div className="flex gap-3 shrink-0">
          <Button onClick={handleAccept} size="sm" variant="primary">
            Aceptar todo
          </Button>
        </div>
      </div>
    </div>
  );
};
